// extracted by mini-css-extract-plugin
export var aTagButton = "exchangeDetail-module--aTagButton--0ada4";
export var description = "exchangeDetail-module--description--993c8";
export var descriptionTitle = "exchangeDetail-module--descriptionTitle--193c1";
export var exchangeLogo = "exchangeDetail-module--exchangeLogo--8f82d";
export var mobileMarginTop = "exchangeDetail-module--mobileMarginTop--6488f";
export var noDataCard = "exchangeDetail-module--noDataCard--eade7";
export var noDataCardContent = "exchangeDetail-module--noDataCardContent--c1e06";